import { useSnackbar } from 'notistack'
import { useCallback, useEffect, useState } from 'react'
import { AspenDashboardService, DashboardMetricsResponse } from '../client'
import { CancelablePromise } from '../client/core/CancelablePromise'

export const useDashboardMetrics = () => {
    const [metrics, setMetrics] = useState<DashboardMetricsResponse | null>(null)
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<string | null>(null)
    const { enqueueSnackbar } = useSnackbar()

    const fetchDashboardMetrics = useCallback(async () => {
        setLoading(true)
        setError(null)
        try {
            const response: CancelablePromise<DashboardMetricsResponse> = AspenDashboardService.getDashboardMetricsDashboardMetricsGet()
            const data = await response
            setMetrics(data)
        } catch (err) {
            setError('Failed to fetch dashboard metrics')
            enqueueSnackbar('Failed to fetch dashboard metrics', { variant: 'error' })
        } finally {
            setLoading(false)
        }
    }, [enqueueSnackbar])

    useEffect(() => {
        fetchDashboardMetrics()
    }, [fetchDashboardMetrics])

    return { metrics, loading, error, fetchDashboardMetrics }
}
